import React, { useEffect, useState } from "react";
import { theme, websiteColors } from "../../themes/Theme";
import { getFeaturedEvents } from "../../crud/event.crud";
import ShimmerGrid from "../../components/ShimmerGrid";
import EventCard from "../../components/eventCard";

const HomeEventSection: React.FC = () => {
	const [featuredEvents, setFeaturedEvents] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const fetchEventData = async () => {
		try {
			const response = await getFeaturedEvents({ featured_category: "Marathon" });
			setFeaturedEvents(response.data.featuredEvents);
			setIsLoading(false);
		} catch (error) {
			console.error("Error fetching featured events:", error);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchEventData();
	}, []);

	return (
		<div>
			<div className="px-sm-5 font-figtree px-3 text-center mt-sm-2 mt-3 py-5">
				<h6 className="text-uppercase heading-label mb-3">Featured Marathons</h6>
				<h1 className="display-5 main-heading">Spotlight on Unmissable Marathons</h1>
				<p className="lead main-sub-heading mt-3">
					No more dull days! Check out our exciting marathon line-up and register for
					upcoming marathon
				</p>
				<div className="row d-flex justify-content-center align-items-center position-relative">
					<div
						className="row d-flex flex-column"
						style={{ width: "1170px", position: "relative" }}
					>
						<div className="d-flex justify-content-end justify-content-md-center justify-content-lg-end mt-5 mb-3">
							<a
								href="https://konfhub.com/events/India?category=Marathon"
								className="view-all-link"
								target="_blank"
								rel="noopener noreferrer"
								style={{
									fontWeight: 600,
									color: websiteColors[theme].primaryWebsiteTheme,
									textDecoration: "underline",
									cursor: "pointer"
								}}
							>
								View All
							</a>
						</div>
						<div className="row d-flex">
							{isLoading ? (
								<ShimmerGrid count={3} />
							) : featuredEvents.length === 0 ? (
								<div
									style={{ minHeight: "100px" }}
									className="no-resource-found text-center mt-5"
								>
									No events found
								</div>
							) : (
								featuredEvents
									.slice(0, 3)
									.map((event, index) => <EventCard key={index} event={event} />)
							)}
						</div>
					</div>
				</div>
				<style jsx>{`
					.heading-label {
						color: ${websiteColors[theme].primaryWebsiteTheme};
						font-size: 16px;
						font-weight: 600;
						line-height: 24px;
					}

					.main-sub-heading {
						color: ${websiteColors[theme].textSecondary};
						font-size: 24px;
						font-weight: 400;
						line-height: 30px;
					}

					.main-heading {
						color: #001a47 !important;
						font-size: 48px;
						font-weight: 600;
						line-height: 57.6px;
						letter-spacing: -2px;
						color: #001234;
					}

					@media (max-width: 576px) {
						.main-heading {
							font-size: 32px;
							font-weight: 600;
							line-height: 38.4px;
						}

						.main-sub-heading {
							font-size: 20px;
							font-weight: 500;
						}
					}
				`}</style>
			</div>
		</div>
	);
};

export default HomeEventSection;
